
jQuery(document).ready(function($) {
    const wishlistItemsContainer = document.getElementById('swym_main_collection_product_grid');
    let variant__Id = '';

    function fetchProduct(){
      window._swat.fetchWrtEventTypeET(function(wishlistProducts) {
        let productitem="";
  //       console.log(wishlistProducts);
        wishlistProducts.forEach(function(product){
          console.log(product);

          let addtobtn_text = "Add to cart"
          product.isInCart = _swat.platform.isInDeviceCart(product.epi);
          productitem += `<li class="grid__item product_li_vId_${product.epi}" id="product_li__${product.epi}"> <div class="card-wrapper">

                          <a href=""
                          data-epi="${product.epi}"
                          data-empi="${product.empi}"
                          data-du="${product.du}"
                          data-iu="${product.iu}" data-pr="${product.pr}" data-stk="${product.stk}" data-variants="${product.vi}"
                          class="remove">X</a>
<div class="card card--product card--outline" tabindex="-1">
                          <div class="card__inner">
                          <div class="card__badge" id="sale_badge_${product.epi}"></div>
                          <div>
                          <div class="media media--transparent media--square media--hover-effect">
                          <img src="${product.iu}"
                          alt="${product.dt}"
                          class="motion-reduce"
                          width="1000" height="1000">
                            </div>
                            </div>
                            </div>
                            </div>
                          <div class="card-information"><div class="card-information__wrapper">

                          <div class="caption-with-letter-spacing light">
  <a class="vendor__name__${product.empi}" href=""></a>
    </div>

  <h3 class="card-information__text h5">
  <a href="${product.du}" class="full-unstyled-link">
  ${product.dt} <span id="var_title__${product.epi}"></span>
                            </a>
                            </h3>
                          <div class="price " data-wg-notranslate="manual">
                          <div>
                          <div class="price__regular">
                              <span class="price-item price-item--sale price-item--last" id="com_price__${product.epi}"></span>
                              <span class="price-item price-item--regular">

                                  <span id="product_price__${product.epi}">${product.pr}</span>

                              </span>
                          </div>
                          </div>
                          </div>
                          <div id="yotpo-category-stars">
                              <div class="yotpo bottomLine" data-product-id="${product.empi}"></div>
                          </div>
                            </div>
                            </div>
                          

                          <a href="" id="${product.epi}" data-product-id="${product.empi}" data-url="${product.du}" data-variant-id="${product.epi}" class="product-form__submit button button--full-width button--primary add-to-cart">${addtobtn_text}</a>
                           <a id="noti_${product.epi}" href="${product.du}?variant=${product.epi}" data-noti_variant-id="${product.epi}" class="button button--full-width button--primary hide notifyme col_notify_btn ">Notify Me</a>


    </div> </li>`
          fnc_prouductJson(product);
        });
  // console.log(productitem);
        wishlistItemsContainer.innerHTML = productitem;
        attachClickListeners();
        removeClickListeners();
        console.log('load rating');

        var yotpoIsReady = false;
        (function checkForYotpo() {
        setTimeout(function() {
          if (typeof yotpo !== "undefined") {
            if (yotpo.initialized === true) {
              yotpoIsReady = true;
              var api = new Yotpo.API(yotpo);
              api.refreshWidgets();
            }
          } else {
            console.log('Checking for Yotpo...');
          }
          if (yotpoIsReady === false) checkForYotpo();
        }, 3000);
        })();

      },window._swat.EventTypes.addToWishList);
    }

    function attachClickListeners(){
        $(".add-to-cart").on("click", function(e){
          e.preventDefault();
          var productId = e.target.getAttribute("data-product-id");
          var variantId = e.target.getAttribute("data-variant-id");
          var du = e.target.getAttribute("data-url");
          e.target.innerHTML = "Moving..";
          window._swat.replayAddToCart({empi: productId, du: du},variantId, function() {
              e.target.innerHTML = "Added to cart";
              console.log("Successfully added product to cart.");
             publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: variantId })
             fetch('/?sections=cart-drawer,cart-icon-bubble')
              .then((response) => response.json())
              .then((data) => {
                let response = {"sections":data,"id":variantId }
                const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                cart.renderContents(response);
              });
            },
            function(e) {
              console.log(e);
            }
          );
        });
      }

    function removeClickListeners(){
        $(".remove").on("click", function(e){
          e.preventDefault();

          var epi = e.target.getAttribute("data-epi");
          var empi = e.target.getAttribute("data-empi");
          var du = e.target.getAttribute("data-du");
          var iu = e.target.getAttribute("data-iu");
          var pr = e.target.getAttribute("data-pr");
          var stk = e.target.getAttribute("data-stk");
          var variants = e.target.getAttribute("data-variants");
          window._swat.removeFromWishList({"epi": epi, "du": "'"+du+"'", "empi": empi, "iu" : "'"+iu+"'", "pr": pr, "stk": stk, "variants":`[{"${variants}" : ${epi}}]`},function(r) {
            console.log('Removed to wishlist');
            fetchProduct();
          });
        });
    }

    function fnc_prouductJson(product){
      window._swat.getProductDetails(product, function(productJson) {
        console.log("Entire product json vendor:",productJson);
        variant__Id = product.epi;
        var theVarArray = productJson.variants;
        theVarArray.forEach(variant => {
          console.log(variant.id);
          if(variant__Id == variant.id){
            if(variant.available){
              document.getElementById(`product_li__${variant.id}`).classList.remove('disable');
            }else{
              document.getElementById(`product_li__${variant.id}`).classList.add('disable');
            }
          }
        });

  //       if(productJson.available){
  //         document.getElementById(`product_li__${productJson.id}`).classList.remove('disable');
  //       }else{
  //         document.getElementById(`product_li__${productJson.id}`).classList.add('disable');
  //       }

        var variantPrice = 0,
            variantComPrice = 0,
            varTitle = "",
            varId = ""
            onSale = false;
         productJson.variants && [...productJson.variants].forEach(function(element) {
           if(product.epi == element.id){
             console.log("variant title="+element.title);
             if( element.title != "Default Title"){
             varTitle = "- "+element.title;
             }
             varId =  element.id;
             variantPrice = element.price;
             if(element.compare_at_price > variantPrice ){
             variantComPrice = element.compare_at_price
             onSale = true;
             }
           }
         });


         if(onSale){
          document.getElementById(`sale_badge_${varId}`).innerHTML = '<span class="badge badge--bottom-left color-accent-1" aria-hidden="true">Sale</span>';
         }
        let moneyFormat = document.querySelector('body').getAttribute('money_format');

        var varmainformatedPrice = moneyFormat.replace(/-?[0-9]*\.?[0-9]+/, (variantPrice / 100.00).toFixed(2));
        var varformatedComPrice = moneyFormat.replace(/-?[0-9]*\.?[0-9]+/, (variantComPrice / 100.00).toFixed(2));
        console.log('mainformatedPrice'+varmainformatedPrice);

  //       document.getElementById(`product_price__${varId}`).innerText =`HK${Shopify.formatMoney(variantPrice)}`;
        if(productJson.price_varies){
          // var elemMoneyPrice = boostPFSConfig.label.from_price_html.replace(/{{ price }}/, `HK${varmainformatedPrice}`);
          document.getElementById(`product_price__${varId}`).innerHTML = `<span>From<\/span>  HK${varmainformatedPrice}`;
        }
        else{
          document.getElementById(`product_price__${varId}`).innerText =`HK${varmainformatedPrice}`;
        }

        document.getElementById(`var_title__${varId}`).innerText =varTitle;

        console.log(variantComPrice);
        if(variantComPrice != 0 ){
  //       document.getElementById(`com_price__${varId}`).innerText =`HK${Shopify.formatMoney(variantComPrice)}`;
          document.getElementById(`com_price__${varId}`).innerText =`HK${varformatedComPrice}`;
        }else{
        document.getElementById(`com_price__${varId}`).style.display = "none";
        }
  //       console.log("Entire product json ID:",productJson.id);
  //       console.log("Entire product json ID:",productJson.vendor);


        var  colHandle = productJson.vendor;
        var vendorLink = colHandle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

        let $vendorSelector = document.querySelectorAll(`.vendor__name__${productJson.id}`);
        $vendorSelector && [...$vendorSelector].forEach(function(element) {
          element.innerText =`${productJson.vendor}`;
          element.setAttribute("href","/collections/"+vendorLink);
        });

  //       document.querySelector(`.vendor__name__${productJson.id}`).innerText =`${productJson.vendor}`;
  //       document.querySelector(`.vendor__name__${productJson.id}`).setAttribute("href","/collections/"+vendorLink);



        let varFlagCheck = null;
        productJson.variants.forEach(function(variant) {
          if(variant.id == variant__Id){
            console.log(variant__Id);
            if(variant.available == false ){
              varFlagCheck = false;
              console.log("if");
              document.getElementById(`${variant.id}`).innerText ="Notify Me";
              document.getElementById(`${variant.id}`).classList.add('hide');
              document.getElementById(`noti_${variant.id}`).classList.remove('hide');
            }else{
              varFlagCheck = true;
              console.log("else");
              document.getElementById(`${variant.id}`).innerText ="Add to cart";
              document.getElementById(`${variant.id}`).classList.remove('hide');
              document.getElementById(`${variant.id}`).classList.add('add-to-cart');
            }
          }
        });

      },function(e) {console.log(e);});
    }

     function swymCallbackFn(){

        if(wishlistItemsContainer){
         fetchProduct()
        } else {
          attachClickListeners();
          removeClickListeners();
        }
      }
      if(!window.SwymCallbacks){
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(swymCallbackFn);




    });